import {combineReducers} from 'redux';
import {countriesReducer} from './countries';
import {citiesReducer} from './cities';
import {userReducer} from './user';
import {cryodexReducer} from './cryodex';
import {settingsReducer} from './settings';
import {infodexLinksReducer} from './infodexLinks';
import {linkedInfodexReducer} from './linkedInfodex';
import {crydexGroupsReducer} from './cryodexGroups';
import {infodexGroupsReducer} from './indexGroups';
import {infodexReducer} from './infodex';
import {infodexesReducer} from './infodexes';
import {progressReducer} from '../components/Progress/reducer';
import {linkedCryodexReducer} from './linkedCryodex';
import {mailboxReducer} from './mailbox';
import {favouredInfodexReducer} from './favouredInfodex';
import {friendsReducer} from './friends';
import { allFriendsReducer } from './allFriends';
import { gFriendsReducer } from './gFriends';

const allReducers = combineReducers({
	user:userReducer,	
	countries:countriesReducer,
    cities:citiesReducer,
	cryodexes:cryodexReducer, 
	infodexLinks:infodexLinksReducer,
	linkedInfodex: linkedInfodexReducer,
	infodexes: infodexReducer,  
    linkedCryodex:linkedCryodexReducer,      
    infodex: infodexReducer,
    infodexes: infodexesReducer,    
    cryodexGroups : crydexGroupsReducer,
    infodexGroups : infodexGroupsReducer,
    mailbox: mailboxReducer,    
    favouredInfodex: favouredInfodexReducer,
	friends:friendsReducer,
	allFriends: allFriendsReducer,
	settings: settingsReducer,
	gFriends: gFriendsReducer,
		
});

export default allReducers;